export default (className, containerSettings) => {
  const classes = [className];
  if (containerSettings && containerSettings.spacing !== 'none') classes.push(`spacing-${containerSettings.spacing}`);
  if (containerSettings && containerSettings.theme !== 'none') classes.push(`${containerSettings.theme}-bg`);

  return classes.join(' ');
};
